import { createAction, createAsyncAction } from "typesafe-actions";
import authorizationConstants from "store/features/authorization/authorization.constants";
import { AuthorizationViewModel } from "api";

const {
    AUTHORIZE_REQUEST,
    AUTHORIZE_SUCCESS,
    AUTHORIZE_FAILED,
    WRITE_ACCESS_TOKEN,
    CLEAR_ACCESS_TOKEN,
} = authorizationConstants;

export const authorize = createAsyncAction(AUTHORIZE_REQUEST, AUTHORIZE_SUCCESS, AUTHORIZE_FAILED)<
    string | null,
    AuthorizationViewModel,
    ErrorHandler
>();

export const writeAccessToken = createAction(WRITE_ACCESS_TOKEN)<{
    accessToken: string;
}>();

export const clearAccessToken = createAction(CLEAR_ACCESS_TOKEN)();
